import authFetch from './fetch';
import { makeRequest } from './utils';

const routes = {
  bankingUpdatePath: () => '/api/BankingUpdate',
};

export const getBankingUpdate = () => makeRequest(
  authFetch.get(routes.bankingUpdatePath()),
);
